import { useCallback, useState } from 'react';

import type { Primitive } from 'types';
import { empty } from 'utils/helpers';

export function useListState<T extends Primitive>(
	initialState: T[] = empty.array,
) {
	const [listItems, setItems] = useState<T[]>(initialState);

	const addItems = useCallback((...items: T[]) => {
		setItems((prev) => [...prev, ...items]);
	}, []);

	const removeItems = useCallback((...items: T[]) => {
		setItems((prev) => prev.filter((i) => !items.includes(i)));
	}, []);

	const resetItems = useCallback(() => {
		setItems(initialState);
	}, [initialState]);

	const clearItems = useCallback(() => {
		setItems([]);
	}, []);

	return {
		addItems,
		clearItems,
		items: listItems,
		removeItems,
		resetItems,
		setItems,
	};
}
